/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs */

const en_admin_allocation_form_select_allocatee_placeholder = /** @type {(inputs: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select member or team`)
};

const de_admin_allocation_form_select_allocatee_placeholder = /** @type {(inputs: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglied oder Team auswählen`)
};

const es_admin_allocation_form_select_allocatee_placeholder = /** @type {(inputs: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar miembro o equipo`)
};

const fr_admin_allocation_form_select_allocatee_placeholder = /** @type {(inputs: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner un membre ou une équipe`)
};

/** @type {(inputs: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs) => LocalizedString} */
const it_admin_allocation_form_select_allocatee_placeholder = en_admin_allocation_form_select_allocatee_placeholder;

/** @type {(inputs: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_select_allocatee_placeholder = en_admin_allocation_form_select_allocatee_placeholder;

/** @type {(inputs: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs) => LocalizedString} */
const pl_admin_allocation_form_select_allocatee_placeholder = en_admin_allocation_form_select_allocatee_placeholder;

/** @type {(inputs: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs) => LocalizedString} */
const hu_admin_allocation_form_select_allocatee_placeholder = en_admin_allocation_form_select_allocatee_placeholder;

/** @type {(inputs: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs) => LocalizedString} */
const ro_admin_allocation_form_select_allocatee_placeholder = en_admin_allocation_form_select_allocatee_placeholder;

/**
* | output |
* | --- |
* | "Select member or team" |
*
* @param {Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_select_allocatee_placeholder = /** @type {((inputs?: Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Select_Allocatee_PlaceholderInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_select_allocatee_placeholder(inputs)
	if (locale === "de") return de_admin_allocation_form_select_allocatee_placeholder(inputs)
	if (locale === "es") return es_admin_allocation_form_select_allocatee_placeholder(inputs)
	if (locale === "fr") return fr_admin_allocation_form_select_allocatee_placeholder(inputs)
	if (locale === "it") return it_admin_allocation_form_select_allocatee_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_select_allocatee_placeholder(inputs)
	if (locale === "pl") return pl_admin_allocation_form_select_allocatee_placeholder(inputs)
	if (locale === "hu") return hu_admin_allocation_form_select_allocatee_placeholder(inputs)
	return ro_admin_allocation_form_select_allocatee_placeholder(inputs)
});
export { admin_allocation_form_select_allocatee_placeholder as "admin.allocation_form.select_allocatee_placeholder" }